import { useEffect, useState } from "react";
import { getAssetBlob } from "../../db/database";

export function useAssetUrl(hash?: string): string | undefined {
  const [url, setUrl] = useState<string>();

  useEffect(() => {
    let active = true;
    let objectUrl: string | undefined;
    setUrl(undefined);
    if (!hash) return;

    void getAssetBlob(hash).then((blob) => {
      if (!active || !blob) return;
      objectUrl = URL.createObjectURL(blob);
      setUrl(objectUrl);
    });

    return () => {
      active = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [hash]);

  return url;
}

